<script>
import LazyImage from "@/components/atoms/lazy-image";
import LinkTo from "@/components/atoms/link-to";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider";
import ButtonIcon from "@/components/molecules/button-icon";
import Popin from "@/components/molecules/popin";
import StickyFooter from "@/components/molecules/sticky-footer";
import ButtonNavigation from "@/components/molecules/button-navigation";
import AchatExpressMobile from "@/components/organisms/header/achats-express/mobile";
import RecettesMobile from "@/components/organisms/header/recettes/mobile";
import MonMagasinMobile from "@/components/organisms/header/mon-magasin/mobile";
import MenuMobile from "@/containers/menu";
import MenuLayerMobile from "@/components/organisms/header/menu/menu-layer/mobile";
import MenuSeo from "@/containers/menu/menu-seo";
import List from "@/components/molecules/list";
import ListItemNavigation from "@/components/molecules/list-item-navigation";
import coraproLogo from "@/assets/images/corapro-logo.svg";
import logoCoraService from "@/assets/images/logo-cora-service.svg";
import coraLogo from "@/assets/images/cora-logo-cercle.svg";

export default {
  name: "HeaderMenuPopin",
  components: {
    LazyImage,
    LinkTo,
    Icon,
    Divider,
    Popin,
    ButtonIcon,
    StickyFooter,
    ButtonNavigation,
    AchatExpressMobile,
    MonMagasinMobile,
    MenuMobile,
    MenuLayerMobile,
    List,
    ListItemNavigation,
    MenuSeo,
    RecettesMobile
  },
  props: {
    isNational: {
      type: Boolean,
      required: false,
      default: true
    },
    shopName: {
      type: String,
      required: false,
      default: ""
    },
    shopPageLink: {
      type: String,
      required: false,
      default: ""
    },
    shopId: {
      type: Number,
      required: false,
      default: null
    },
    shopfirstSlotAvailable: {
      type: String,
      required: false,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    webAlias: {
      type: String,
      required: false,
      default: ""
    },
    isHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    coinDesMarquesIds: {
      type: Array,
      required: false,
      default: () => []
    },
    showIdeesRepas: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["openOrcloseStoreLocator", "hideMenu"],
  data() {
    return {
      logoCoraService: logoCoraService,
      corapro: coraproLogo,
      coraLogo: coraLogo,
      categorySelected: null,
      isBrand: false,
      categoryDisplayed: null,
      showMenu: false
    };
  },
  computed: {
    haveCoinDesMarques() {
      return (
        this.categoryDisplayed &&
        this.categoryDisplayed.attributes.children &&
        this.categoryDisplayed.attributes.children.data.filter((children) =>
          this.coinDesMarquesIds.includes(children.id)
        ).length > 0
      );
    }
  },
  methods: {
    toggleShopButton() {
      if (this.isNational) {
        this.$emit("openOrcloseStoreLocator");
      } else {
        this.pushOrReload({
          path: `/magasins/${this.webAlias}-m-${this.shopId}`
        });
      }
    },
    selectCategory(category) {
      this.categoryDisplayed = category;
      this.categorySelected = category;
    },
    show() {
      this.showMenu = true;
    },
    hide() {
      this.isBrand = false;
      this.reset();
      this.$emit("hideMenu");
      this.showMenu = false;
    },
    reset() {
      this.categorySelected = null;
    },
    displayCategory(category) {
      this.categoryDisplayed = category;
      this.isBrand = this.coinDesMarquesIds.includes(category.id);
    },
    pushOrReload(options) {
      if (typeof options === "string") {
        options = { path: options };
      }
      if (options.path && !options.query && options.path === this.$route.path) {
        this.$router.go();
      } else {
        navigateToInternal(options);
      }
    }
  }
};
</script>

<template>
  <div>
    <MenuSeo
      v-if="isNational && isHomePage"
      is-mobile
    />
    <Popin
      ref="popin"
      :visible="showMenu"
      v-bind="removeClassAndStyleFromAttrs($attrs)"
      side-bar
      side-bar-position="left"
      class="c-menu-popin"
      aria-label="Menu"
      @closed="reset()"
    >
      <div
        class="u-flex u-full-height u-flex-column"
        :class="['c-header-menu-popin', categorySelected && 'c-header-menu-popin--sublvl']"
      >
        <div class="u-flex-grow">
          <div
            v-if="!categorySelected"
            class="c-header-menu-popin__header"
          >
            <ButtonIcon
              icon-name="cross-thin"
              icon-color="primary"
              icon-color-hover="grey-1"
              icon-size="lg"
              class="u-mr-xs"
              aria-label="Fermer le menu"
              @click="hide()"
            />
            <Divider
              class="c-header-menu-popin__header-divider"
              vertical
            />
            <LinkTo
              to="/"
              class="c-header-menu-popin__logo u-ml-sm"
            >
              <LazyImage
                :src="coraLogo"
                alt="Logo Cora"
                width="43"
                height="36"
              />
              <span
                v-if="!isNational && shopName"
                class="c-header-menu-popin__logo-baseline u-color-grey-1 u-mt-xxs"
              >{{ shopName }}</span>
              <span
                v-else
                class="c-header-menu-popin__logo-baseline u-color-grey-2 u-mt-xxs"
              >
                Magasins, Drive, Livraison, Retrait
              </span>
            </LinkTo>
          </div>
          <template v-if="!categorySelected && shopId && !isNational ">
            <MonMagasinMobile
              v-if=" !customer || (customer && !customer.attributes.pro)"
              :shopfirst-slot-available="shopfirstSlotAvailable"
              class="c-header-menu-popin__mon-magasin"
            />
          </template>

          <div
            :class="haveCoinDesMarques ? 'u-mb-none' : 'u-mb-sm'"
            class="c-header-menu-popin__content"
          >
            <template v-if="!categorySelected">
              <h2 class="c-header-menu-popin__title u-mb-xs">
                <Icon
                  name="achat-express"
                  size="md"
                  variant="primary"
                  class="u-mr-sm"
                />
                Achat Express
              </h2>
              <AchatExpressMobile class="c-header-menu-popin__achat-express u-mb-md" />
              <Divider />
              <h2 class="c-header-menu-popin__title u-mt-md u-mb-xs">
                <Icon
                  name="hamburger"
                  size="md"
                  variant="primary"
                  class="u-mr-sm"
                />
                Nos rayons
              </h2>
              <MenuMobile
                class="c-header-menu-popin__menu"
                @selectCategory="selectCategory"
              />
              <template v-if="showIdeesRepas">
                <Divider />
                <h2 class="c-header-menu-popin__title u-mt-md u-mb-xs">
                  <Icon
                    name="recipe-book"
                    size="md"
                    variant="primary"
                    class="u-mr-sm"
                  />
                  Nos recettes et idées repas
                </h2>
                <RecettesMobile class="c-header-menu-popin__achat-express u-mb-md" />
              </template>
            </template>

            <template v-else>
              <MenuLayerMobile
                :category="categorySelected"
                :coin-des-marques-ids="coinDesMarquesIds"
                @close="categorySelected = null"
                @displayCategory="displayCategory"
              />
            </template>
          </div>
          <div
            v-if="!isBrand"
            class="u-mb-sm u-ml-xs u-mr-xs"
          >
            <Divider class="u-m-none" />
            <list>
              <ListItemNavigation
                variant="corapro"
                no-border
                to="/infos-et-services/les-magasins-cora/profitez-des-services/cora-pro"
              >
                <LazyImage
                  :src="corapro"
                  alt="Corapro"
                  height="16"
                />
              </ListItemNavigation>
              <Divider class="u-m-none" />
              <ListItemNavigation
                :image="logoCoraService"
                image-alt="Cora service"
                variant="services-infos"
                to="/infos-et-services"
                no-border
                image-width="32"
                image-height="26"
              >
                <span class="u-color-primary u-font-500">Services & infos magasins</span>
              </ListItemNavigation>
            </list>
            <Divider class="u-m-none" />
          </div>

          <div class="u-mx-sm">
            <ButtonIcon
              icon-name="cross-thin"
              icon-color="grey-2"
              icon-size="xs40"
              icon-color-hover="primary-light"
              link
              no-underline
              aria-label="Fermer le menu"
              class="u-mt-xs"
              @click="hide()"
            >
              <span class="u-font-12">Fermer le menu</span>
            </ButtonIcon>
          </div>
        </div>

        <StickyFooter
          :in-dom="false"
          menu-popin
          class="c-header-menu-popin__footer"
        >
          <div class="c-header-menu-popin__footer-navigation">
            <ButtonNavigation
              :notification-available="!isNational"
              icon-name="shop"
              icon-color="primary"
              icon-size="md"
              class="u-flex-item-fluid"
              @click="toggleShopButton()"
            >
              <template #button-content>
                <span class="u-text-center u-block u-mt-xs">Mon magasin</span>
              </template>
            </ButtonNavigation>

            <Divider
              vertical
              class="u-my-none u-mx-xxs"
            />

            <ButtonNavigation
              :notification-available="customer!==null"
              icon-name="user-outline"
              icon-color="primary"
              icon-size="md"
              class="u-flex-item-fluid"
              @click="$showAuth(() => { pushOrReload('/mon-compte') })"
            >
              <template #button-content>
                <span
                  v-if="customer!==null"
                  class="u-text-center u-block u-mt-xs"
                >{{ customer.attributes.prenom }}</span>
                <span
                  v-else
                  class="u-text-center u-block u-mt-xs"
                >Mon compte</span>
              </template>
            </ButtonNavigation>
            <Divider
              vertical
              class="u-my-none u-mx-xxs"
            />
            <ButtonNavigation
              icon-name="prospectus"
              icon-color="primary"
              icon-size="md"
              class="u-flex-item-fluid"
              :to="'/prospectus'"
            >
              <template #button-content>
                <span class="u-text-center u-block u-mt-xs">Prospectus</span>
              </template>
            </ButtonNavigation>
            <Divider
              v-if="!(customer && customer.attributes.pro)"
              vertical
              class="u-my-none u-mx-xxs"
            />
            <ButtonNavigation
              v-if="!(customer && customer.attributes.pro)"
              icon-name="cora-card"
              icon-color="primary"
              icon-size="md"
              class="u-flex-item-fluid"
              :to="customer ? '/mon-compte/ma-fidelite' : '/accueil-fidelite'"
            >
              <template #button-content>
                <span class="u-text-center u-block u-mt-xs">Ma fidélité</span>
              </template>
            </ButtonNavigation>
          </div>
        </StickyFooter>
      </div>
    </Popin>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/header-menu-popin.scss";
</style>
